var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoSoma01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1202",
    d: "M29,7.6v-3H9.5L21,16.9c0.7,0.8,0.7,2,0,2.7L9.7,31.4H29v-1.8c0-1.1,0.9-2,2-2c1.1,0,1.9,0.9,2,2v3.8 c0,1.1-0.9,2-2,2H5c-1.1,0-2-0.9-2-2c0-0.5,0.2-1,0.6-1.4l13.3-13.8L3.5,3.9C2.8,3.1,2.8,1.9,3.6,1.1C4,0.8,4.5,0.6,5,0.6H31 c1.1,0,2,0.9,2,2v5c0,1.1-0.9,2-2,2C29.9,9.5,29.1,8.6,29,7.6L29,7.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoSoma01);
export default __webpack_public_path__ + "static/media/ico-funcao-soma-01.a815c800b415580a207a20c825bdb1cf.svg";
export { ForwardRef as ReactComponent };